/* import __COLOCATED_TEMPLATE__ from './jp-smirf-enrollment-form.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import JpSmirfService from '@dashboard/shared-ui/clients/jpsmirf';
import { OptInRequest } from '@square/dashboard-protos/models/squareup/jpsmirf/externalservice';
import { getFormattedSmirfCpRate, isInSmirfPricingPlan } from '@dashboard/shared-ui/utils/jp-smirf';
import { htmlSafe } from '@ember/template';
var EnrollmentSelection = /*#__PURE__*/function (EnrollmentSelection) {
  EnrollmentSelection["NONE"] = "NONE";
  EnrollmentSelection["ENROLL"] = "ENROLL";
  EnrollmentSelection["DO_NOT_ENROLL"] = "DO_NOT_ENROLL";
  return EnrollmentSelection;
}(EnrollmentSelection || {});
var PricingType = /*#__PURE__*/function (PricingType) {
  PricingType["SMIRF_PRICING_PLAN"] = "SMIRF_PRICING_PLAN";
  PricingType["JP_SMIRF_SERVICE"] = "JP_SMIRF_SERVICE";
  return PricingType;
}(PricingType || {}); // Configuration mapping pricing types to translation key suffixes
const PRICING_TYPE_TRANSLATION_CONFIG = {
  SMIRF_PRICING_PLAN: {
    heading: 'headingPnp',
    enrollHeading: 'headingPnp',
    enrollSubtext: 'subtextPnp',
    dontEnrollHeading: 'headingPnp',
    dontEnrollSubtext: 'subtextPnp',
    finePrint: 'finePrintPnp'
  },
  JP_SMIRF_SERVICE: {
    heading: 'headingV2',
    enrollHeading: 'heading',
    enrollSubtext: 'subtext',
    dontEnrollHeading: 'heading',
    dontEnrollSubtext: 'subtext',
    finePrint: 'finePrintV2'
  }
};

/**
 * Helper function to get translation keys based on pricing type
 */
function getTranslationKey(pricingType, textType) {
  const suffix = PRICING_TYPE_TRANSLATION_CONFIG[pricingType][textType];
  const baseKeyMap = {
    heading: 'jpSmirf.enrollmentForm',
    enrollHeading: 'jpSmirf.enrollmentForm.options.enroll',
    enrollSubtext: 'jpSmirf.enrollmentForm.options.enroll',
    dontEnrollHeading: 'jpSmirf.enrollmentForm.options.dontEnroll',
    dontEnrollSubtext: 'jpSmirf.enrollmentForm.options.dontEnroll',
    finePrint: 'jpSmirf.enrollmentForm'
  };
  return `${baseKeyMap[textType]}.${suffix}`;
}
let JpSmirfEnrollmentFormComponent = (_class = class JpSmirfEnrollmentFormComponent extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "EnrollmentSelection", EnrollmentSelection);
    // expose EnrollmentSelection to the hbs template
    _initializerDefineProperty(this, "marketToasts", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "enrollmentSelection", _descriptor3, this);
    _initializerDefineProperty(this, "hasError", _descriptor4, this);
    _initializerDefineProperty(this, "isLoading", _descriptor5, this);
  }
  selectEnrollOption() {
    this.enrollmentSelection = EnrollmentSelection.ENROLL;
    this.hasError = false;
  }
  selectDontEnrollOption() {
    this.enrollmentSelection = EnrollmentSelection.DO_NOT_ENROLL;
    this.hasError = false;
  }
  async submit() {
    if (this.enrollmentSelection === EnrollmentSelection.NONE) {
      this.hasError = true;
      return;
    }
    this.isLoading = true;
    const isEligible = this.enrollmentSelection === EnrollmentSelection.ENROLL ? true : false;
    try {
      const response = await JpSmirfService.optIn(OptInRequest.create({
        isEligible
      }));
      this.args.onSubmit(response.success);
    } catch {
      this.marketToasts.critical(this.intl.t('common.serverError'));
    }
    this.isLoading = false;
  }
  get isInSmirfPricingPlan() {
    return isInSmirfPricingPlan(this.args.getRegistrationInfoResponse);
  }
  get formattedRate() {
    return getFormattedSmirfCpRate(this.intl, this.args.getRegistrationInfoResponse);
  }
  get pricingType() {
    return this.isInSmirfPricingPlan ? PricingType.SMIRF_PRICING_PLAN : PricingType.JP_SMIRF_SERVICE;
  }
  get titleText() {
    return htmlSafe(this.intl.t(getTranslationKey(this.pricingType, 'heading')));
  }
  get enrollHeadingText() {
    return htmlSafe(this.intl.t(getTranslationKey(this.pricingType, 'enrollHeading')));
  }
  get enrollSubtextText() {
    return htmlSafe(this.intl.t(getTranslationKey(this.pricingType, 'enrollSubtext')));
  }
  get dontEnrollHeadingText() {
    return htmlSafe(this.intl.t(getTranslationKey(this.pricingType, 'dontEnrollHeading')));
  }
  get dontEnrollSubtextText() {
    return htmlSafe(this.intl.t(getTranslationKey(this.pricingType, 'dontEnrollSubtext')));
  }
  get finePrintText() {
    return htmlSafe(this.intl.t(getTranslationKey(this.pricingType, 'finePrint'), {
      cpRate: this.formattedRate
    }));
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "marketToasts", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "enrollmentSelection", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return EnrollmentSelection.ENROLL;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "hasError", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isLoading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "selectEnrollOption", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectEnrollOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectDontEnrollOption", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectDontEnrollOption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "submit"), _class.prototype), _class);
export { JpSmirfEnrollmentFormComponent as default };